// extracted by mini-css-extract-plugin
export default {"produceaisle":"produceaisle_ecf4f8aec16e11b5f30a","name":"name_bf557259c941112bc597"};